import { render, staticRenderFns } from "./litleBadgeNew.vue?vue&type=template&id=1d277e16&scoped=true&"
import script from "./litleBadgeNew.vue?vue&type=script&lang=js&"
export * from "./litleBadgeNew.vue?vue&type=script&lang=js&"
import style0 from "./litleBadgeNew.vue?vue&type=style&index=0&id=1d277e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d277e16",
  null
  
)

export default component.exports